// extracted by mini-css-extract-plugin
export default {"shadowed":"About_shadowed__KV44D","pink":"About_pink__L2WsY","green":"About_green__CrlRR","skills":"About_skills__p8rSh"};